import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationLocationItamsConstants {
    static STEP_TITLE = "Location";
    static REMOVE_BAY_LABEL = "Remove bay";
    static LAYER_REF = "ITAMS graphics";
    static BAY_REQUIRED = "Please select a bay before continuing with the create application process";
    static BAYS_FORM_GROUP_NAME = "baysForm";
    static ADDRESS_CONTROL = "address";
    static BAY_NUMBER_CONTROL = "bayNumber";
    static BAY_SIZE_CONTROL = "baySize";
    static GEOMETRY_CONTROL = "geometry";
    static CENTROID_CONTROL = "centroid";
    static BAYS_CONTROL = "bays";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static BAY_NUMBER_PLACEHOLDER = "Bay number";
    static BAY_SIZE_TEXT_PLACEHOLDER = "Bay size";
    static DUPLICATE_MESSAGE = "The selected bay has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static VALIDATION_MESSAGES = {
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, bayNumber: {
            required: `Bay number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, baySize: {
            required: `Bay size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
